import script from "./IcpView.vue?vue&type=script&setup=true&lang=js"
export * from "./IcpView.vue?vue&type=script&setup=true&lang=js"

import "./IcpView.vue?vue&type=style&index=0&id=ce2a4606&lang=scss"

const __exports__ = script;

export default __exports__